import { Component, Inject, Input, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { DOCUMENT } from '@angular/common'
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends FeaturesBaseComponent implements OnInit {
  @Input() sideMenu: RouteInfo[];
  @Input() facebookUrl : string;
  @Input() instagramUrl : string;
  menuItems: any[];

  constructor(@Inject(DOCUMENT) private document: Document, public dialog: MatDialog, private loginService: LoginService, private router: Router) {
    super();
  }
  ngOnInit() {
    this.menuItems = this.sideMenu.filter(menuItem => menuItem);
  }
  isMobileMenu() {
    let _width = window.innerWidth || this.document.documentElement.clientWidth || this.document.body.clientWidth;
    if (_width > 991) {
      return false;
    }
    return true;
  };
  //On Logout click
  onLogout() {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        message: "pages.placeholders.AreYousureyouwanttologout",
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // alert(`Logout Successful!`);
        this.loginService.logout().subscribe(e => {
          // console.log(e)

          if (e.httpcode == 200) {
            localStorage.clear();
            this.router.navigateByUrl('/logout')
          }
          return
        });
        localStorage.clear();
        this.router.navigateByUrl('/logout')
        return
      }
    });
  }
}


